import { render } from "./GuessesDialog.vue?vue&type=template&id=5c4e5d64&scoped=true&ts=true"
import script from "./GuessesDialog.vue?vue&type=script&lang=ts"
export * from "./GuessesDialog.vue?vue&type=script&lang=ts"

import "./GuessesDialog.vue?vue&type=style&index=0&id=5c4e5d64&scoped=true&lang=css"

import exportComponent from "C:\\Users\\breno\\Documents\\Workspace\\Coll\\palavra-quadrada\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4e5d64"]])

export default __exports__